import { Link } from 'react-router-dom';
import AdminLayout from '../../components/AdminLayout';

export default function AdminContent(){
 return <AdminLayout title="Content" description="General website copy and non-portfolio content belong here.">
  <section className="studio-admin-card studio-admin-grid">
   <div><p className="admin-eyebrow">CONTENT BOUNDARY</p><h2>Portfolio images now have their own dedicated workspace.</h2><p>This prevents nail-photo uploads from being mixed with future homepage copy, About text, FAQs and other website content.</p></div>
   <div className="studio-admin-actions"><Link className="studio-admin-btn primary" to="/admin/portfolio">Open Portfolio Manager</Link></div>
  </section>
  <section className="studio-admin-grid metrics">
   <article className="studio-admin-metric"><span>Portfolio images</span><strong>Separate</strong><small>Managed under Portfolio</small></article>
   <article className="studio-admin-metric"><span>Homepage copy</span><strong>Planned</strong><small>Future controlled editor</small></article>
   <article className="studio-admin-metric"><span>About and FAQs</span><strong>Planned</strong><small>Future controlled editor</small></article>
   <article className="studio-admin-metric"><span>Current safety</span><strong>Live</strong><small>No duplicate upload controls</small></article>
  </section>
 </AdminLayout>
}
